import { logger } from '../logger';
import { analyticsService } from './analyticsService';

export async function initAnalytics(): Promise<void> {
  try {
    const level = import.meta.env.VITE_ANALYTICS_LEVEL || 'essential';
    analyticsService.setAnalyticsLevel(level);

    if (import.meta.env.VITE_ENABLE_ANALYTICS === 'true') {
      analyticsService.enableAnalytics();
    } else {
      analyticsService.disableAnalytics();
    }
  } catch (error) {
    logger.error('Error initializing analytics', {
      category: 'Analytics',
      data: { error }
    });
  }
}
